import { UPDATE_SUPER_USER_FAILURE, UPDATE_SUPER_USER_SUCCESS } from "redux/constants/MyM"

const initState = { data: [], error: false, errorData: "", isLoading: true }

export default (state = initState, action) => {
    switch (action.type) {
        case UPDATE_SUPER_USER_SUCCESS:
            return {
                ...state, data: action.payload, isLoading: false
            }
        case UPDATE_SUPER_USER_FAILURE:
            return {
                ...state, errorData: action.payload, error: true, isLoading: false
            }
        default:
            return {
                ...state
            }
    }
}